module.exports = __webpack_public_path__ + "static/media/atu.a4d5b29a.png";